var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sf-select-option",class:{ 'sf-select-option--is-active': _vm.selected === _vm.value },attrs:{"role":"option","aria-selected":_vm.selected === _vm.value ? 'true' : 'false'},on:{"click":_vm.clicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }